import React from 'react';
import './Title.css';
import topLeftMenu from '../../Images/Menus/TopLeftMenu.png';
import topRightMenu from '../../Images/Menus/TopRightMenu.png';
import RoundDisplay from '../RoundDisplay/RoundDisplay';
import ScoreDisplay from '../ScoreDisplay/ScoreDisplay';

class Title extends React.Component {

  render() {
    return (
      <div className="titleDisplay">
        <div className="topLeftSection">
          {this.props.status.mode === "Menu" ? <h1 className="leftTitleText">PROJECT</h1> : <RoundDisplay mode={this.props.status.mode} round={this.props.status.round} roundScore={this.props.status.roundScore} snagBonus={this.props.snagBonus} showSnags={this.props.showSnags} hideSnags={this.props.hideSnags} questionStyle={this.props.questionStyle} />}
          <img src={topLeftMenu} alt="topLeftFame" className="topLeftFrame"/>
        </div>
        <div></div>
        <div className="topRightSection">
          {this.props.status.mode === "Menu" ? <h1 className="rightTitleText">STROOP</h1> :
              <ScoreDisplay mode={this.props.status.mode} totalScore={this.props.status.totalScore} snagBonus={this.props.snagBonus}/>}
          <img src={topRightMenu} alt="topRightFrame" className="topRightFrame"/>
        </div>
      </div>
    )
  }
}

export default Title;



// WEBPACK FOOTER //
// ./src/Components/Title/Title.js